
const sectorsByCategory = {
  "Life Sciences": [
    "Pharmaceuticals",
    "Medical Devices and Supplies",
    "Healthcare",
    "Diagnostics and Biotech",
    "Therapeutics",
    "Healthcare IT"
  ],
  "Consumer Goods": [
    "Consumer Electronics",
    "Home Products",
    "Luxury and high value products",
    "Personal care and cosmetic",
    "Apparel and Fashion",
    "Retailing",
    "Consumer and general services",
    "Sports, Fitness and Leisure",
    "Baby products and supplies",
    "Office products and supplies",
    "Pet products and supplies",
    "Entertainment Products",
    "Travel and Luxury Travel",
    "Packaging",
    "Hospitality"
  ],
  "Materials and Chemicals": [
    "Renewable, Speciality and fine chemicals",
    "Bulk Chemicals",
    "Composites",
    "Advanced Materials",
    "Paints, Coatings and Additives"
  ],
  "Construction and Manufacturing": [
    "Packaging",
    "Manufacturing",
    "Manufacturing Services",
    "Engineering, Equipment and Machinery",
    "Heavy Manufacturing",
    "Roads and Highways",
    "Residential Construction and Improvement",
    "HVAC",
    "Construction Materials"
  ],
  "Food and Beverages": [
    "Food Services and Hospitality",
    "Food Ingredient",
    "Additives and Supplements",
    "Advanced Packaging and Tracking Technologies",
    "Wellness food",
    "Convenience Food",
    "Agriculture and Agri Products",
    "Beverages"
  ],
  "Energy and Power": [
    "Renewable Energy",
    "Non-Renewable Energy",
    "Storage and Distribution",
    "Combined Heat and Power",
    "Energy Efficiency and Conservation",
    "Utility",
    "Equipment and Devices"
  ],
  "Semiconductor and Electronics": [
    "Sensors and Controls",
    "Semiconductors",
    "Electronic Security",
    "Electronic Systems and Devices",
    "Display Technologies",
    "Emerging and Next Generation Technologies"
  ],
  "Automotive and Transportation": [
    "Infotainment, Navigation and Telematics",
    "Safety and Security Systems",
    "Automotive Aftermarket",
    "Electric and Hybrid Vehicles",
    "Freight and Logistics",
    "Automotive systems and accessories"
  ],
  "ICT and Media": [
    "Telecom and Wireless",
    "Information, Infrastructure and Network Security",
    "High Tech, Enterprise and Consumer IT",
    "Communication Services - Providers and Operators",
    "Software and Services",
    "E Commerce and Outsourcing",
    "Entertainment and Media Technologies",
    "Infotainment, Navigation and Telematics"
  ],
  "Aerospace and Defense": [
    "Commercial Aviation",
    "Defence",
    "Homeland Security",
    "Space"
  ],
  "BFSI": [
    "Insurance",
    "Banking",
    "Financial Services",
    "IT in BFSI"
  ]
};

export default sectorsByCategory